var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumb3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 82",
    style: {
      enableBackground: "new 0 0 120 82"
    },
    xmlSpace: "preserve",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#fff;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.4,64.1c-0.6,0-1.1-0.4-1.3-1l-4-16.2c-0.2-0.7,0.3-1.4,1-1.6c0.1,0,0.2,0,0.3,0h24.2c0.7,0,1.3,0.6,1.3,1.3 v16.2c0,0.7-0.6,1.3-1.3,1.3L76.4,64.1z M77.4,61.4h17.9V47.9H74.1L77.4,61.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.3,64.1c-0.7,0-1.3-0.6-1.3-1.3c0,0,0,0,0,0V46.6c0-0.7,0.6-1.3,1.3-1.3h24.3c0.7,0,1.3,0.6,1.3,1.4 c0,0.1,0,0.2,0,0.3l-4,16.1c-0.2,0.6-0.7,1-1.3,1L23.3,64.1z M24.7,61.4h17.8l3.4-13.5H24.7V61.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.1,80.7c-3.3,0-6.3-1.8-7.8-4.8L63.7,67c-1-2.1-3.6-2.9-5.6-1.9c-0.8,0.4-1.5,1.1-1.9,1.9l-4.5,8.9 c-1.5,3-4.5,4.8-7.8,4.8H9.8C4.9,80.7,1,76.8,1,72V41.4c0-2.6,1.2-5.1,3.2-6.7l0.2-0.2l8.6-32c0.2-0.7,0.8-1.2,1.5-1.2l0,0 c0.7,0,1.3,0.4,1.6,1l5,13.1c0.3,0.8-0.1,1.7-0.9,2.1c0,0,0,0,0,0c-0.2,0.1-0.4,0.1-0.6,0.1c-0.7,0-1.3-0.4-1.5-1l-3.2-8.4L8.2,32.6 h1.6h100.6h1.3l-0.3-1.2l-6.3-23.4l-3.2,8.4c-0.2,0.6-0.8,1-1.5,1c-0.6,0-1.2-0.4-1.5-0.9c-0.1-0.4-0.1-0.8,0-1.2l5-13.1 c0.2-0.6,0.8-1,1.5-1c0.7,0,1.4,0.5,1.5,1.2l8.6,32l0.2,0.2c2,1.7,3.2,4.1,3.2,6.7V72c0,4.8-3.9,8.8-8.8,8.8H76.1z M60,61.5 c2.8,0,5.4,1.6,6.6,4.1l4.5,8.9c0.9,1.9,2.9,3.1,5,3.1h34.1c3.1,0,5.6-2.5,5.6-5.6V41.4c0-3.1-2.5-5.6-5.6-5.6H9.8 c-3.1,0-5.6,2.5-5.6,5.6V72c0,3.1,2.5,5.6,5.6,5.6h34.1c2.1,0,4-1.2,5-3.1l4.5-8.9C54.6,63,57.2,61.4,60,61.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb3);
export default __webpack_public_path__ + "static/media/thumb-3.85cd289937baa52c7102bb8b62652c40.svg";
export { ForwardRef as ReactComponent };